import { instance as axiosToken, setJwtToken, setMultiPartHeader } from "../../config/axiosInstance";
import { instance as axios } from "../../config/axiosInstance";
// ---------report-data-----------------------
export const getReportDataApi = async (data) => {
    // console.log('data getReportDataApi', data)
    const endPoint = `user/analytics/report` + '?' + new URLSearchParams({ ...data }).toString()
    return await axios.get(endPoint, setJwtToken());
};
// ---------dashboard-data-----------------------
export const getDashboardDataApi = async (data) => {
    const endPoint = `user/analytics/dashboard` + '?' + new URLSearchParams({ ...data }).toString()
    return await axios.get(endPoint, setJwtToken());
};

// -------------------------------------bill------------------------------------------------------------------

// ---------transaction-List-Api-----------------------
export const transactionListApi = async (data) => {
    const endPoint = `user/bill/transaction` + '?' + new URLSearchParams({ ...data }).toString()
    return await axios.get(endPoint, setJwtToken());
};
// ---------electricity-Generation-pApi-list-Api-----------------------
export const electricityGenerationApi = async (data) => {
    const endPoint = `user/bill/monthly-report` + '?' + new URLSearchParams({ ...data }).toString()
    return await axios.get(endPoint, setJwtToken());
};

// -------------------------bill-due-Api-pay-now------------------------
// export const bilDuePayApi = async (data) => {
//     return await axios.post(`user/bill/pay`, data, setJwtToken());
// };
// ----------------create-order-payment-----------------
export const initiatePaymentApi = async (data) => {
    return await axios.post(`user/bill/create_order`, data, setJwtToken());
};

// ---------download-Report-Api-----------------------
export const downloadReportApi = async (data) => {
    const endPoint = `user/analytics/download_report` + '?' + new URLSearchParams({ ...data }).toString()
    return await axios.get(endPoint, setJwtToken());
};

// ----------export-excel-Api-----------------------
export const exportExcelApi = async (data) => {
    const endPoint = `user/bill/export_billing` + '?' + new URLSearchParams({ ...data }).toString()
    return await axios.get(endPoint, setJwtToken());
};
// ----------download-bill-Api-----------------------
export const downloadBillApi = async (data) => {
    console.log(' downloadBillApi data', data)
    const endPoint = `user/bill/export_single_billing` + '?' + new URLSearchParams({ ...data }).toString()
    return await axios.get(endPoint, setJwtToken());
};